// :cow: Cosmose CONFIDENTIAL :iso:
import { createAction, props } from '@ngrx/store';
import { AdvertiserListResponse } from '@par/app/core/model/dictionaries.response';

export const getAdvertiserListRequested = createAction('[SELECT ADVERTISER] Get Advertiser List Requested');
export const getAdvertiserListSucceeded = createAction('[SELECT ADVERTISER] Get Advertiser List Succeeded', props<{
  response: AdvertiserListResponse
}>());
export const getAdvertiserListFailed = createAction('[SELECT ADVERTISER] Get Advertiser List Failed');
